import { api, apiUrl } from "../../shared/services/service";
import type {
  AdminEmailDailyCountsResponse,
  AdminEmailDateRange,
  AdminEmailMailboxesResponse,
  AdminEmailMessageResponse,
  AdminEmailMessagesResponse,
} from "../models/admin-email.models";
import { ADMIN_EMAIL_BODY_CHUNK_SIZE, ADMIN_EMAIL_PAGE_SIZE } from "../utils/admin-email.constants";
import { getAdminMonitoringErrorMessage } from "./admin-monitoring.service";

// Request only mailbox IDs from the backend's committed catalog.
// The backend owns authorization, the mailbox whitelist, and validation of opaque page cursors.
export const getAdminEmailMailboxes = async (signal: AbortSignal): Promise<AdminEmailMailboxesResponse> => {
  const response = await api.get(`${apiUrl}/admin/emails/mailboxes`, { signal });

  return response.data;
};

// === EMAIL ===

export const getAdminEmailMessages = async (
  mailboxId: string,
  cursor: string | undefined,
  signal: AbortSignal,
): Promise<AdminEmailMessagesResponse> => {
  const response = await api.get(`${apiUrl}/admin/emails/${encodeURIComponent(mailboxId)}/messages`, {
    params: { pageSize: ADMIN_EMAIL_PAGE_SIZE, ...(cursor ? { cursor } : {}) },
    signal,
  });

  return response.data;
};

// === EMAIL ===

export const getAdminEmailMessage = async (
  mailboxId: string,
  messageId: string,
  signal: AbortSignal,
  bodyOffset = 0,
): Promise<AdminEmailMessageResponse> => {
  const response = await api.get(
    `${apiUrl}/admin/emails/${encodeURIComponent(mailboxId)}/messages/${encodeURIComponent(messageId)}`,
    { signal, params: { bodyOffset, maxCharacters: ADMIN_EMAIL_BODY_CHUNK_SIZE } },
  );

  return response.data;
};

// === EMAIL ===

export const getAdminEmailDailyCounts = async (
  mailboxId: string,
  range: AdminEmailDateRange,
  signal: AbortSignal,
): Promise<AdminEmailDailyCountsResponse> => {
  const response = await api.get(`${apiUrl}/admin/emails/${encodeURIComponent(mailboxId)}/daily-counts`, {
    params: range,
    signal,
  });

  return response.data;
};

export const getAdminEmailErrorMessage = getAdminMonitoringErrorMessage;
